import { Select, Typography } from 'antd';
import clsx from 'clsx';
import moment from 'moment';
import DatePicker from '../../../../../lib/MomentDatePicker';
import { IBestDataset } from '../../../../../types/analytics';
import { DateFormat } from '../../../../../utils/StaticVariable';
import styles from '../../../Analytics/components/Layout/AnalyticsLayout.module.scss';

const { Text } = Typography;

interface ReportsInputFormProps {
  datasets: IBestDataset[];
  datasetSW: string | null;
  datasetHD: string | null;
  datasetWind: string | null;
  onSelectDataset: (type: 'SW' | 'HD' | 'Wind') => (value: string) => void;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  onStartDateChange: (date: moment.Moment | null) => void;
  onEndDateChange: (date: moment.Moment | null) => void;
  disabledStartDate: (date: moment.Moment) => boolean;
  disabledEndDate: (date: moment.Moment) => boolean;
  isOfflineDataset: { sw: boolean; hd: boolean; wind: boolean };
  timeStep: string;
}

export default function ReportsInputForm({
  datasets,
  datasetSW,
  datasetHD,
  datasetWind,
  onSelectDataset,
  timeStep,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabledStartDate,
  disabledEndDate,
  isOfflineDataset,
}: ReportsInputFormProps) {
  const offlineDatasetFieldInfo = (condition?: boolean) => {
    return (
      <div className={styles.fieldWrapper}>
        {condition && (
          <small className={styles.fieldError}>
            This dataset is not available online
          </small>
        )}
      </div>
    );
  };
  return (
    <div className={styles.formRow}>
      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Waves</Text>
        <Select
          id='Reports-Dataset_Waves_Input'
          value={datasetSW || '-'}
          onChange={onSelectDataset('SW')}
          placeholder='Select dataset'
        >
          <Select.Option value='-'>None</Select.Option>
          {datasets
            .filter((item) => item.label === 'Waves')
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.value}
              </Select.Option>
            ))}
        </Select>
        {offlineDatasetFieldInfo(isOfflineDataset.sw)}
      </div>

      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Ocean</Text>
        <Select
          id='Reports-Dataset_Ocean_Input'
          value={datasetHD || '-'}
          onChange={onSelectDataset('HD')}
          placeholder='Select dataset'
        >
          <Select.Option value='-'>None</Select.Option>
          {datasets
            .filter((item) => item.label === 'Ocean')
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.value}
              </Select.Option>
            ))}
        </Select>
        {offlineDatasetFieldInfo(isOfflineDataset.hd)}
      </div>

      <div className={`${styles.formItem} ${styles.datasetItem}`}>
        <Text>Atmosphere</Text>
        <Select
          id='Reports-Dataset_Atmosphere_Input'
          value={datasetWind || '-'}
          onChange={onSelectDataset('Wind')}
          placeholder='Select dataset'
        >
          <Select.Option value='-'>None</Select.Option>
          {datasets
            .filter((item) => item.label === 'Atmosphere')
            .map((item) => (
              <Select.Option key={item.id} value={item.id}>
                {item.value}
              </Select.Option>
            ))}
        </Select>
        {offlineDatasetFieldInfo(isOfflineDataset.wind)}
      </div>

      <div
        className={clsx(
          styles.formItem,
          styles.dateItem,
          styles.fieldAdditionalPadding
        )}
        data-testid='Reports-StartDate_Input'
      >
        <Text>Start Date</Text>
        <DatePicker
          value={startDate}
          disabledDate={disabledStartDate}
          onChange={onStartDateChange}
          format={DateFormat}
        />
      </div>

      <div
        className={clsx(
          styles.formItem,
          styles.dateItem,
          styles.fieldAdditionalPadding
        )}
        data-testid='Reports-EndDate_Input'
      >
        <Text>End Date</Text>
        <DatePicker
          value={endDate}
          disabledDate={disabledEndDate}
          onChange={onEndDateChange}
          format={DateFormat}
        />
      </div>

      <div
        className={clsx(
          styles.formItem,
          styles.dateItem,
          styles.fieldAdditionalPadding
        )}
      >
        <Text>Time Step</Text>
        <Select
          id='Reports-TimeStep_Input'
          value={timeStep}
          placeholder='Select dataset'
          disabled={true}
        ></Select>
      </div>
    </div>
  );
}
